module.exports = __webpack_public_path__ + "static/media/welcome-confirmation.ed3971cf.png";